import { lang } from '@umu/ukit-lang';
/**
 * @description
 */

import './pagination.scss';

import React, { useCallback } from 'react';
import { Iconfont } from '@umu/umu-design';

interface IProps {
    currentPage: number;
    maxPage: number;
    forceShow?: boolean;
    showSizeChanger?: boolean; // 小方格的风格
    onPageChange?(page: number): void;
}

const PAGE_OFFSET = 4;

export default function Pagination({ currentPage, maxPage, forceShow, showSizeChanger, ...props }: IProps) {
    currentPage = Number(currentPage);
    maxPage = Number(maxPage);
    let start = currentPage - PAGE_OFFSET;
    let end = currentPage + PAGE_OFFSET;

    // 确保最多展示 2*offset+1 个
    if (start < 1) {
        const padding = Math.abs(1 - start);
        start += padding;
        end += padding;
    } else if (end > maxPage) {
        const padding = Math.abs(end - maxPage);
        start -= padding;
        end -= padding;
    }

    // 防止越界
    start = Math.max(1, start);
    end = Math.min(end, maxPage);

    // 生成页码列表
    const list = Array.from(Array(end - start + 1).keys()).map((_) => _ + start);

    const showHead = currentPage === 1;
    const showTail = currentPage === maxPage;
    const showJumpPrev = list.indexOf(1) === -1;
    const showJumpNext = list.indexOf(maxPage) === -1;
    const showJumpPerPage = maxPage > 5;

    const onClick = useCallback(
        (page: number) => {
            if (page === currentPage) {
                return;
            }
            if (props.onPageChange) {
                props.onPageChange(page);
            }
        },
        [currentPage, props.onPageChange],
    );

    const onJump = useCallback(
        (offset: number) => {
            let page = currentPage + offset;
            if (page < 1) {
                page = 1;
            } else if (page > maxPage) {
                page = maxPage;
            }
            onClick(page);
        },
        [currentPage, props.onPageChange],
    );

    if (!forceShow && list.length <= 1) {
        return null;
    }

    return (
        <div className={showSizeChanger ? `pagination-bar pagination-bar-change` : `pagination-bar`}>
            <ul className="page-list">
                {!showSizeChanger && !showHead ? (
                    <li className="page-item" onClick={() => onClick(1)}>
                        {lang('首页')}
                    </li>
                ) : null}
                {showJumpPerPage && !showHead ? (
                    <li className="page-item flex--center" onClick={() => onJump(-1)}>
                        {showSizeChanger ? <Iconfont type="SmallBack" /> : <i className="icon icon-arrow arrow1 blue size-xs left"/>}
                    </li>
                ) : null}
                {showJumpPrev ? (
                    <li className="page-item flex--center" onClick={() => onJump(-10)}>
                        <Iconfont type="More" />
                    </li>
                ) : null}
                {list.map((page) => {
                    return (
                        <li
                            key={page}
                            className={'page-item' + (page === currentPage ? ' current' : '')}
                            onClick={() => onClick(page)}
                        >
                            {page}
                        </li>
                    );
                })}
                {showJumpNext ? (
                    <li className="page-item flex--center" onClick={() => onJump(10)}>
                        <Iconfont type="More" />
                    </li>
                ) : null}
                {forceShow || (showJumpPerPage && !showTail) ? (
                    <li className="page-item flex--center" onClick={() => onJump(1)}>
                        {showSizeChanger ? <Iconfont type="SmallMore" /> : <i className="icon icon-arrow arrow1 blue size-xs right"/>}
                    </li>
                ) : null}
                {(!showSizeChanger && !showTail || forceShow) ? (
                    <li className="page-item" onClick={() => onClick(maxPage)}>
                        {lang('尾页')}
                    </li>
                ) : null}
            </ul>
        </div>
    );
}
